/**
 * @name addSecureProtocolToUrl
 * @description Adds 'https://' to the beginning of a url.
 */
export const addSecureProtocolToUrl = (url: string): string => `https://${url}`;
